<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1">
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <!--      <template v-slot:cell(contractorName)="data">-->
      <!--        <div style="color: #4caedc" @click="showDetail(data.item.contractorName)">{{ data.item.contractorName }}</div>-->
      <!--      </template>-->
      <!--      <template v-slot:cell(joinDate)="data">-->
      <!--        {{moment(data.item.joinDate).format("YYYY-MM-DD")}}-->
      <!--      </template>-->
      <!--      <template v-slot:cell(leaveDate)="data">-->
      <!--        {{-->
      <!--          (data.item.leaveDate === '' || data.item.leaveDate === undefined) ? '-' : moment(data.item.leaveDate).format("YYYY-MM-DD")-->
      <!--        }}-->
      <!--      </template>-->
      <template v-slot:cell(varietyGrossWeight)="data">
        {{ Number(data.item.varietyGrossWeight).toFixed(2) }}
      </template>
      <template v-slot:cell(agreePackWeight)="data">
        {{ Number(data.item.agreePackWeight).toFixed(3) }}
      </template>
      <template v-slot:cell(packNum)="data">
        {{ Number(data.item.packNum).toFixed(0) }}
      </template>
      <template v-slot:cell(packWeightTotal)="data">
        {{ Number(data.item.packWeightTotal).toFixed(2) }}
      </template>
      <template v-slot:cell(varietyNetWeight)="data">
        {{ Number(data.item.varietyNetWeight).toFixed(2) }}
      </template>
      <template v-slot:cell(companyName)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.companyName)">{{ data.item.companyName }}</div>
      </template>
      <template v-slot:cell(farmName)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.farmName)">{{ data.item.farmName }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
<!--      <template v-slot:foot()="scope">-->
<!--        <div class="text-nowrap" :style="{textAlign:'center'}">-</div>-->
<!--      </template>-->
<!--      <template v-slot:foot(laborTypeLabel)="data">-->
<!--        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>-->
<!--      </template>-->
<!--      <template v-slot:foot(employeeNum)="data">-->
<!--        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'employeeNum') }}</div>-->
<!--      </template>-->
      <!--            <template v-slot:foot(estimateAmount)="data">-->
      <!--              <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'estimateAmount')}}</div>-->
      <!--            </template>-->
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "itsOrderDepartDetail",
  data() {
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'departName', label: '冷库', width: '120px'},
        {key: 'companyName', label: '贸易公司名称', width: '120px'},
        {key: 'brandName', label: '产品品牌', width: '120px'},
        {key: 'varietyLevelLabel', label: '产品等级', width: '120px'},
        {key: 'packModelLabel', label: '单件规格', width: '120px'},
        {key: 'packName', label: '包装材料名称', width: '120px'},
        {key: 'model', label: '包装材料规格', width: '120px'},
        {key: 'agreePackWeight', label: '约定包装材料重量（斤/件）', width: '150px'},
        {key: 'varietyGrossWeight', label: '含筐总重（斤）', width: '100px'},
        {key: 'packNum', label: '装车件数', width: '100px'},
        {key: 'packWeightTotal', label: '装车件包装材料总重（斤）', width: '150px'},
        {key: 'varietyNetWeight', label: '不含筐总重（斤）', width: '140px'},
      ],
      items: [],
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>